<template>
  <section v-on:click="sectionClicked">
    <Header :class="{scrolled: isScrolled}" ref="header"/>
    <div class="welcome">
      <div class="cnt">
        <div class="text">
          <h2>
            <template v-if="loadingStats">...</template>
            <template v-else>{{treeStats.treePlanted.toLocaleString('id')}}</template>
            Pohon <span>Sudah DiTanam</span></h2>
          <p>Lebih dari
            <template v-if="loadingStats">...</template>
            <template v-else>{{treeStats.userJoined.toLocaleString('id')}}</template>
            orang telah bergabung dan mengikuti
            tantangan harian bersama-sama dan mendapatkan pohon</p>
          <button v-on:click="joinChallenge">Ikuti Tantangan</button>
          <button class="secondary" v-on:click="viewReport">Lihat Laporan Penanaman</button>
        </div>
        <div class="earth">
          <div class="tree tree1"></div>
          <div class="tree tree2"></div>
          <div class="tree tree3"></div>
          <div class="tree tree4"></div>
          <div class="tree tree5"></div>
          <div class="tree tree6"></div>
        </div>
      </div>
    </div>
    <div class="challenge">
      <div class="cnt">
        <div class="challengeCnt">
          <div class="chlL">
            <div class="chImgCnt">
              <div class="chImg img1"></div>
              <div class="chImg img2"></div>
              <div class="chImg img3"></div>
              <div class="chImg img4"></div>
              <div class="chImg img5"></div>
            </div>
          </div>
          <div class="chlR">
            <h4>Tantangan Setiap Hari</h4>
            <p>Terdapat 32 tantangan yang bisa diikuti setiap hari
              dan telah diikuti oleh
              <template v-if="loadingStats">...</template>
              <template v-else>{{treeStats.userJoined.toLocaleString('id')}}</template>
              orang lebih. Setiap
              orang yang mengikuti tantangan dan memperoleh point
              1.400 akan mendapatkan pohon untuk di tanamkan di hutan
              dan ikut serta menyelamtkan bumi.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="report" ref="report">
      <div class="cnt">
        <h4>Laporan Penanaman Pohon</h4>
        <p>
          <template v-if="loadingStats">...</template>
          <template v-else>{{treeStats.treePlanted.toLocaleString('id')}}</template>
          pohon dengan berbagai species sudah ditanamkan,
          kamu bisa melihat pohon apa aja yang sudah ditanamkan atas nama
          peserta <span>TEAM UP EVERYDAY</span></p>
        <div class="tabCnt">
          <div class="tabItem active">
            <h4>Penanaman Tahap 1</h4>
            <p>Sumatra Barat</p>
          </div>
          <div class="tabItem comingSoon">
            <h4>Penanaman Tahap 2</h4>
            <p>Coming Soon</p>
          </div>
          <div class="tabItem comingSoon tab3">
            <h4>Penanaman Tahap 3</h4>
            <p>Coming Soon</p>
          </div>
        </div>
        <div class="reportCnt">
          <div class="reportItem" v-for="(item, i) in treeData" :key="i"
            v-on:click="viewDetail(item)">
            <div class="reportIn">
              <div class="icon"></div>
              <h4>Pohon {{item.localname}}</h4>
              <p>{{item.desa}}</p>
              <span class="viewDetail">Lihat informasi pohon</span>
            </div>
          </div>
        </div>
        <div class="viewAllCnt">
          <div class="viewAllLoading" v-if="viewAllLoading"></div>
          <div class="viewAll" v-else-if="canViewAll"
            v-on:click="viewAll">Lihat semua data pohon</div>
        </div>
      </div>
    </div>
    <div class="mapIntro">
      <div class="cnt">
        <h4>Map Penanaman Pohon</h4>
      </div>
    </div>
    <div class="glMapRoot" id="glMapRoot">
      <div class="glMap" id="glMapbox"></div>
    </div>
    <Tree ref="tree"/>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';
import Tree from '@/components/Tree.vue';

const mapboxgl = require('mapbox-gl/dist/mapbox-gl.js');

export default {
  name: 'home',
  components: { Header, Tree },
  data() {
    return {
      isScrolled: false,
      loadingStats: true,
      treeStats: null,
      loadingData: true,
      treeData: [],
      canViewAll: true,
      viewAllLoading: false,
      allData: [],
      scAlTimer: null,
    };
  },
  computed: {},
  methods: {
    sectionClicked() {},
    scrolled() {
      this.isScrolled = window.scrollY > 30;

      /**
       * Analytic scroll event
       *
       */
      if (this.scAlTimer) clearTimeout(this.scAlTimer);
      this.scAlTimer = setTimeout(() => {
        this.$emit('fireal', 'scroll', 'teamup_everyday_landing');
      }, 500);
    },
    joinChallenge() {
      this.$router.push('/team-up-everyday/play');
      this.$emit('fireal', 'teamup_everydat_join_challenge', 'teamup_everyday_landing');
    },
    viewDetail(item) {
      this.$refs.tree.open(null, item);
      this.$emit('fireal', 'teamup_everydat_view_tree', 'teamup_everyday_landing');
    },
    viewReport() {
      this.$refs.report.scrollIntoView();
      this.$emit('fireal', 'teamup_everydat_view_report', 'teamup_everyday_landing');
    },
    viewAll() {
      this.$emit('fireal', 'teamup_everydat_view_all_tree', 'teamup_everyday_landing');
      this.viewAllLoading = true;
      setTimeout(() => {
        this.viewAllLoading = false;
        this.canViewAll = false;
        this.treeData = this.allData;
      }, 600);
    },
    loadMap() {
      const treeLocation = [101.193874, -2.189861];
      mapboxgl.accessToken = 'pk.eyJ1IjoiaHViZW45MiIsImEiOiJiR3FCVmV3In0.hzd66_D0305xk9vZYwOzTA';
      this.map = new mapboxgl.Map({
        container: 'glMapbox',
        style: 'mapbox://styles/huben92/cl2xhe7si000815lszcchr1u6',
        center: treeLocation,
        zoom: 12,
      });
      const nav = new mapboxgl.NavigationControl();
      this.map.scrollZoom.disable();
      this.map.addControl(nav, 'top-right');
      this.map.on('click', () => {
        this.$emit('fireal', 'map_interaction', 'teamup_everyday_landing', {
          type: 'click',
        });
      });
      this.map.on('dragend', () => {
        this.$emit('fireal', 'map_interaction', 'teamup_everyday_landing', {
          type: 'drag',
        });
      });
      this.map.on('zoomend', () => {
        this.$emit('fireal', 'map_interaction', 'teamup_everyday_landing', {
          type: 'zoom',
        });
      });
      this.map.on('load', () => {
        // eslint-disable-next-line
        for (const item of this.allData) {
          const el = document.createElement('div');
          el.className = 'marker2';
          const marker = new mapboxgl.Marker(el).setLngLat(
            [item.longitude, item.latitude],
          ).addTo(this.map);
          marker.getElement().addEventListener('click', () => {
            this.viewDetail(item);
          });
        }
      });
    },
    fireAlEvent(convId) {
      this.$emit('fireal', 'page_visit', 'teamup_everyday_landing', null, convId, (r) => {
        if (r.data.status !== 200) return;
        alTimer = setTimeout(() => {
          this.fireAlEvent(r.data.id);
        }, 5000);
      });
    },
  },
  created() { document.addEventListener('scroll', this.scrolled); },
  destroyed() { document.removeEventListener('scroll', this.scrolled); },
  beforeDestroy() {
    if (alTimer) clearTimeout(alTimer);
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.title = 'Team Up Everyday - Team Up For Impact';
    this.$http.get(this.$config.uri('user/tree/info/main')).then((r) => {
      this.treeStats = r.data.data;
      this.loadingStats = false;
    });
    this.$http.get(this.$config.uri('user/tree/data?limit=12')).then((r) => {
      this.treeData = (r.data.status === 200) ? r.data.data : [];
      this.loadingData = false;
    });
    this.$http.get(this.$config.uri('user/tree/data')).then((r) => {
      this.allData = (r.data.status === 200) ? r.data.data : [];
      setTimeout(() => {
        this.loadMap();
      }, 500);
    });

    this.fireAlEvent();
  },
};
</script>

<style scoped lang="scss">
.welcome{
  position: relative;
  overflow: hidden;
  // background-image: url(../assets/BG.jpg);
  background-image: linear-gradient(45deg, #f3f2ff, #fff5f5);
  // background-image: url(../assets/home-blur.jpg);
  background-size: cover;
  background-position: center;
  .cnt{
    .earth{
      position: absolute;
      width: 1800px;
      height: 640px;
      background-color: red;
      border-radius: 50%;
      left: 460px; top: 520px;
      background-color: #ecebff;
      background-image: linear-gradient(75deg, #95ba45, #c1d39a);
      @media (max-width: 1620px) {
        left: 360px;
      }
      @media (max-width: 1480px) {
        left: 260px;
      }
      @media (max-width: 1340px) {
        left: 160px;
      }
      @media (max-width: 1240px) {
        left: 80px;
      }
      @media (max-width: 1040px) {
        left: -20px;
      }
      @media (max-width: 680px) {
        transform: scale(.6);
        left: auto; right: -840px;
        top: 600px;
      }
      &:before{
        content: "";
        position: absolute;
        width: 540px; height: 120px;
        border-radius: 50%;
        background-color: #e1d0be;
        top: 10px; left: 600px;
      }
      .tree{
        width: 240px; height: 400px;
        position: absolute;
        top: -330px; left: 740px;
        background-image: url(../assets/tree-croped.png);
        background-size: contain;
        background-position: center bottom;
        background-repeat: no-repeat;
        z-index: 7;
        &:before{
          content: "";
          position: absolute;
          left: 0; right: 0; bottom: 0;
          height: 100px;
        }
        &.tree1{
          top: -340px;
          margin-left: -40px;
          transform-origin: bottom;
          transform: scale(.8);
          z-index: 2;
        }
        &.tree2{
          top: -340px;
          margin-left: -70px;
          transform-origin: bottom;
          transform: scale(.8);
          z-index: 2;
        }
        &.tree3{
          top: -330px;
          margin-left: -50px;
          transform-origin: bottom;
          transform: scale(.6);
          z-index: 8;
        }
        &.tree4{
          top: -330px;
          margin-left: 50px;
          transform-origin: bottom;
          transform: scale(1.1);
          z-index: 4;
        }
        &.tree5{
          top: -330px;
          margin-left: 70px;
          transform-origin: bottom;
          transform: scale(.7);
          z-index: 2;
        }
      }
    }
    .text{
      position: relative;
      z-index: 3;
      padding: 300px 0 220px;
      max-width: 640px;
      @media (max-width: 860px) {
        text-align: center;
        margin: 0 auto;
      }
      @media (max-width: 680px) {
        padding: 240px 0;
      }
      h2{
        font-size: 54px;
        color: #5351a4;
        text-transform: uppercase;
        margin: 0 0 10px;
        font-weight: 800;
        font-family: 'GolosUIWebBold', sans-serif;
        @media (max-width: 860px) {
          font-size: 46px;
          line-height: 1.1;
        }
        @media (max-width: 680px) {
          font-size: 36px;
        }
        span{
          color: #f14724;
          display: block;
        }
      }
      p{
        margin: 0 0 30px;
        font-size: 24px;
        @media (max-width: 860px) {
          font-size: 20px;
        }
        @media (max-width: 680px) {
          font-size: 18px;
        }
      }
      button{
        transition: all .3s ease;
        @media (max-width: 860px) {
          margin: 0 auto 14px !important;
          width: 300px;
        }
      }
      button.secondary{
        background: none;
        border: #5351a4 2px solid;
        margin-left: 10px;
      }
    }
  }
}
.challenge{
  overflow: hidden;
}
.challengeCnt{
  display: flex;
  padding: 240px 0 120px;
  vertical-align: middle;
  align-items: center;
  @media (max-width: 1100px) {
    display: block;
    padding-bottom: 60px;
  }
  @media (max-width: 680px) {
    padding: 160px 0 60px;
  }
  .chlL{
    width: 50%;
    @media (max-width: 1100px) {
      width: auto;
      margin: 0 0 80px;
    }
    @media (max-width: 680px) {
      margin: 0 0 50px;
    }
    .chImgCnt{
      position: relative;
      width: 360px; height: 360px;
      @media (max-width: 1100px) {
        margin: 0 auto;
        transform: translateX(-70px);
      }
      @media (max-width: 860px) {
        width: 280px; height: 280px;
      }
      @media (max-width: 680px) {
        width: 160px; height: 160px;
      }
      .chImg{
        position: absolute;
        left: 0; top: 0;
        width: 100%; height: 100%;
        background-color: red;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        transition: all .3s ease;
        border-radius: 10px;
        &.img1{
          transform: rotate(-10deg);
          background-image: url(../assets/Team_Up_Senin_April_2022_Square.png);
        }
        &.img2{
          transform: rotate(-8deg);
          background-image: url(../assets/Team_Up_Jumat_April_2022_Square.png);
          left: 40px;
        }
        &.img3{
          transform: rotate(-6deg);
          background-image: url(../assets/Team_Up_Selasa_April_2022_Square.png);
          left: 80px;
        }
        &.img4{
          transform: rotate(-4deg);
          background-image: url(../assets/Team_Up_Kamis_April_2022_Square.png);
          left: 120px;
        }
        &.img5{
          transform: rotate(-2deg);
          background-image: url(../assets/Team_Up_Minggu_Oktober_2022_Square.png);
          left: 160px;
        }
      }
      &:hover{
        @media (min-width: 1100px) {
          .chImg{
            &.img1{
              transform: none;
            }
            &.img2{
              transform: none;
              left: 200px;
            }
            &.img3{
              transform: none;
              left: 400px;
            }
            &.img4{
              transform: none;
              left: 600px;
            }
            &.img5{
              transform: none;
              left: 800px;
            }
          }
        }
      }
    }
  }
  .chlR{
    width: 50%;
    padding-left: 60px;
    box-sizing: border-box;
    @media (max-width: 1100px) {
      width: auto;
      padding: 0;
      text-align: center;
    }
    h4{
      color: #5351a4;
      font-size: 36px;
      margin: 0 0 10px;
      font-family: 'GolosUIWebBold', sans-serif;
      @media (max-width: 680px) {
        font-size: 24px;
        margin: 0 0 10px;
      }
    }
    p{
      font-size: 18px;
      color: #767676;
      line-height: 1.4;
      @media (max-width: 680px) {
        font-size: 15px;
        margin: 0;
      }
    }
  }
}
.report{
  text-align: center;
  margin: 0 0 200px;
  padding-top: 120px;
  @media (max-width: 1100px) {
    padding-top: 80px;
  }
  @media (max-width: 680px) {
    margin-bottom: 140px;
  }
  h4{
    margin: 0 0 10px;
    color: #5351a4;
    font-size: 36px;
    font-family: 'GolosUIWebBold', sans-serif;
    @media (max-width: 680px) {
      font-size: 24px;
    }
  }
  p{
    color: #767676;
    margin: 0 auto;
    max-width: 680px;
    @media (max-width: 680px) {
      font-size: 15px;
    }
  }
  .tabCnt{
    display: flex;
    padding: 40px 0;
    justify-content: center;
    @media (max-width: 680px) {
      padding: 20px 0;
    }
    .tabItem{
      border: #eee 1px solid;
      border-radius: 5px;
      margin: 0 10px;
      padding: 8px 16px;
      h4{
        color: #444;
        font-size: 15px;
        margin: 0;
      }
      p{
        font-size: 14px;
      }
      &.active{
        border-color: #5351a4;
      }
      &.comingSoon{
        @media (max-width: 680px) {
          display: none;
        }
        h4, p{
          color: #999;
        }
      }
    }
  }
  .reportCnt{
    position: relative;
    display: flex;
    flex-wrap: wrap;
    @media (max-width: 560px) {
      display: block;
    }
    .reportItem{
      width: 25%;
      text-align: left;
      box-sizing: border-box;
      padding: 0 10px 20px;
      @media (max-width: 1100px) {
        width: 33.3333333333%;
      }
      @media (max-width: 680px) {
        width: 50%;
      }
      @media (max-width: 560px) {
        width: auto;
      }
      .reportIn{
        padding: 14px 16px;
        border: #f5f5f5 1px solid;
        cursor: pointer;
        transition: all .3s ease;
        padding-left: 50px;
        position: relative;
        .icon{
          position: absolute;
          left: 10px; top: 10px; bottom: 10px;
          width: 30px;
          background-image: url(../assets/tree-medium-croped.png);
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
        }
        &:hover{
          box-shadow: 2px 2px 4px rgba(0,0,0,.1);
        }
      }
      h4{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 17px;
        color: #444;
        margin: 0 0 2px;
      }
      p{
        font-size: 15px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .viewDetail{
        color: #5351a4;
        font-size: 14px;
      }
    }
  }
  .viewAllCnt{
    text-align: center;
    padding: 20px 0 0;
    .viewAllLoading{
      height: 36px;
      background-image: url(../assets/loading.svg);
      background-size: 34px auto;
      background-position: center;
      background-repeat: no-repeat;
    }
    .viewAll{
      display: inline-block;
      padding: 6px 16px;
      border-radius: 50px;
      border: #5351a4 1px solid;
      color: #5351a4;
      cursor: pointer;
      transition: all .3s ease;
      &:hover{
        background-color: #5351a4;
        color: #fff;
      }
    }
  }
}
.mapIntro{
  text-align: center;
  margin: 0 0 40px;
  @media (max-width: 680px) {
    margin: 0 0 20px;
  }
  h4{
    margin: 0 0 10px;
    color: #5351a4;
    font-size: 36px;
    font-family: 'GolosUIWebBold', sans-serif;
    @media (max-width: 680px) {
      font-size: 24px;
    }
  }
  p{
    color: #767676;
    margin: 0;
  }
}
.glMapRoot{
  background-color: #f5f5fe;
  border-radius: 20px 20px 0 0;
  overflow: hidden;
  @media (max-width: 680px) {
    border-radius: 5px 5px 0 0;
  }
  .glMap{
    height: 720px;
    @media (max-width: 860px) {
      height: 600px;
    }
    @media (max-width: 680px) {
      height: 380px;
    }
  }
}
</style>
